import { render, staticRenderFns } from "./add_invoice_template.vue?vue&type=template&id=5f45004b"
import script from "./add_invoice_template.vue?vue&type=script&lang=js"
export * from "./add_invoice_template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports